"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _guacWidgetCore = require("@wsb/guac-widget-core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var styles = {
  bookingDetailsBlock: {
    display: 'flex',
    padding: 'medium',
    minHeight: '100%',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'section'
  },
  bookingDetailsIcon: {
    flexShrink: 0,
    fontColor: 'highlight',
    marginRight: 'small',
    marginTop: '-xxsmall',
    '@xs-only': {
      marginTop: 0,
      flexShrink: 0
    }
  },
  content: {
    width: '100%'
  }
};

var BookingDetailsContent = function BookingDetailsContent(props) {
  var children = props.children,
      footer = props.footer,
      icon = props.icon,
      subtitle = props.subtitle,
      title = props.title;
  var dataAids = props.dataAids || {};
  var contentStyles = props.styles || {};
  var _UX2$Element = _guacWidgetCore.UX2.Element,
      Block = _UX2$Element.Block,
      Details = _UX2$Element.Details,
      Icon = _UX2$Element.Icon,
      Label = _UX2$Element.Label;

  var content = /*#__PURE__*/_react["default"].createElement(Block, {
    style: contentStyles.container || styles.bookingDetailsBlock
  }, icon && /*#__PURE__*/_react["default"].createElement(Icon, {
    style: styles.bookingDetailsIcon,
    icon: icon,
    size: "xlarge"
  }), /*#__PURE__*/_react["default"].createElement(Block, {
    "data-aid": dataAids.content,
    style: styles.content
  }, title && /*#__PURE__*/_react["default"].createElement(Label.Minor, {
    "data-aid": dataAids.title
  }, title, subtitle && /*#__PURE__*/_react["default"].createElement(Details, {
    "data-aid": dataAids.subtitle
  }, subtitle)), children));

  if (footer) {
    return /*#__PURE__*/_react["default"].createElement(Block, {
      style: contentStyles.wrapper
    }, content, footer);
  }

  return content;
};

BookingDetailsContent.propTypes = {
  children: _propTypes["default"].node.isRequired,
  footer: _propTypes["default"].node,
  icon: _propTypes["default"].string.isRequired,
  subtitle: _propTypes["default"].string,
  title: _propTypes["default"].string
};
var _default = BookingDetailsContent;
exports["default"] = _default;